import createApiClient from "./api";

const api = createApiClient();

export const updateReview = async (reviewId, reviewData) => {
  const token = localStorage.getItem("token");
  const response = await api.post(`/reviews/${reviewId}`, reviewData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
